export default __webpack_public_path__ + "81a8a6c8eca32b7034d492ee7579f41d.svg";